import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import { useGroupedWorkspaceDashboardStyles } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";

const SKELETON_ROW_COUNT = 4;
const SKELETON_ROW_KEYS = Array.from(
  { length: SKELETON_ROW_COUNT },
  (_, index) => `grouped-workspace-dashboard-skeleton-row-${index}`,
);

export const GroupedWorkspaceDashboardSkeleton = (): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();

  return (
    <div>
      <span role="status" className={styles.visuallyHidden}>
        Loading…
      </span>
      <div className={styles.groupList} aria-hidden="true">
        {SKELETON_ROW_KEYS.map((key) => (
          <Skeleton key={key}>
            <div className={styles.skeletonRow}>
              <SkeletonItem
                shape="rectangle"
                className={styles.skeletonChevron}
              />
              <SkeletonItem
                animation="wave"
                shape="rectangle"
                className={styles.skeletonName}
              />
              <SkeletonItem shape="rectangle" className={styles.skeletonPill} />
            </div>
          </Skeleton>
        ))}
      </div>
    </div>
  );
};
